import { render, staticRenderFns } from "./ContactPortal.vue?vue&type=template&id=bbad3fa4"
import script from "./ContactPortal.vue?vue&type=script&lang=js"
export * from "./ContactPortal.vue?vue&type=script&lang=js"
import style0 from "./ContactPortal.vue?vue&type=style&index=0&id=bbad3fa4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports